import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthFailureService } from '@app/shared/authentication/services/auth-failure.service';
import {
  HypecastAuthenticationService,
  HypecastCredentials,
} from '@app/shared/authentication/services/authentication.service';
import { __ } from '@app/shared/functions/object.functions';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { Logger } from '../logger.service';
import { RouteService } from '../route.service';

const _log = new Logger('AuthenticationGuard');
export const AUTH_BOOTSTRAP_TIMEOUT_MS = 20_000;

@Service({ autoProvided: false })
export class AuthenticationGuard {
  private readonly authenticationService = inject(HypecastAuthenticationService);
  private readonly authFailure = inject(AuthFailureService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const data = RouteService.MergeData(route);

    return this.authenticationService.credentials$.pipe(
      timeout({ first: AUTH_BOOTSTRAP_TIMEOUT_MS }),
      map((value: HypecastCredentials) => {
        if (!__.IsNullOrUndefined(data['roles'])) {
          return this.authenticationService.hasAnyRole(data['roles'] as string[]);
        }

        return !__.IsNullOrUndefined(value);
      }),
      catchError((error: unknown) => {
        _log.error('Authentication did not complete, blocking route activation', error);
        this.authFailure.fail(error);
        return of(false);
      }),
    );
  }
}
